import { Icon } from '@iconify/react'
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Spinner } from '@nextui-org/react'
import { useState } from 'react'
import { useSocketContextData } from 'src/context/socket'
import { PowerDocsEventsName } from 'src/types/SocketEvents'

export default function EditContactDepartmentModal({ isOpen, onOpenChange, doc, setDoc }) {
  const [updating, setUpdating] = useState<boolean>(false)
  const [departmentName, setDepartmentName] = useState<string>(doc?.departmentName ?? '')
  const [departmentPhone, setDepartmentPhone] = useState<string>(doc?.departmentPhone ?? '')
  const [departmentEmail, setDepartmentEmail] = useState<string>(doc?.departmentEmail ?? '')
  const { io } = useSocketContextData()
  const update = async () => {
    setUpdating(true)
    await io.emitWithAck(PowerDocsEventsName.UPDATE_POWERDOC_CONTACT, {
      departmentName,
      departmentEmail,
      departmentPhone,
      documentUUID: doc.uuid,
      token: localStorage.getItem('accessToken'),
    })
    setDoc((prev) => ({
      ...prev,
      departmentName,
      departmentEmail,
      departmentPhone,
    }))
    setUpdating(false)
    onOpenChange()
  }
  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange} size={'xl'}>
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Edit Contact of Department details</ModalHeader>
            <ModalBody>
              <div className={'flex flex-col gap-4 '}>
                <Input
                  autoFocus
                  variant="faded"
                  labelPlacement="inside"
                  label={'Name'}
                  placeholder="John Doe."
                  className="w-full"
                  classNames={{
                    inputWrapper: [
                      'group-data-[focus-visible=true]:ring-0 group-data-[focus-visible=true]:ring-offset-0',
                    ],
                  }}
                  isClearable
                  onClear={() => setDepartmentName('')}
                  onChange={(e) => setDepartmentName(e.target.value)}
                  value={departmentName}
                  startContent={<Icon icon={'lucide:user'} />}
                />
                <Input
                  variant="faded"
                  labelPlacement="inside"
                  label={'E-mail'}
                  placeholder="doe@acme.corp."
                  className="w-full"
                  classNames={{
                    inputWrapper: [
                      'group-data-[focus-visible=true]:ring-0 group-data-[focus-visible=true]:ring-offset-0',
                    ],
                  }}
                  isClearable
                  onClear={() => setDepartmentEmail('')}
                  onChange={(e) => setDepartmentEmail(e.target.value)}
                  value={departmentEmail}
                  startContent={<Icon icon={'lucide:mail'} />}
                />
                <Input
                  variant="faded"
                  labelPlacement="inside"
                  label={'Phone'}
                  placeholder="+1 (231) 341-2131."
                  className="w-full"
                  classNames={{
                    inputWrapper: [
                      'group-data-[focus-visible=true]:ring-0 group-data-[focus-visible=true]:ring-offset-0',
                    ],
                  }}
                  isClearable
                  onClear={() => setDepartmentPhone('')}
                  onChange={(e) => setDepartmentPhone(e.target.value)}
                  value={departmentPhone}
                  startContent={<Icon icon={'lucide:phone'} />}
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" isDisabled={updating} onPress={update}>
                {updating ? (
                  <>
                    {'Updating details'} <Spinner size={'sm'} />
                  </>
                ) : (
                  'Update'
                )}
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}
